import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

let cached: string | null = null;
let inFlight: Promise<string> | null = null;

const fetchSiteKey = async (): Promise<string> => {
  if (cached) return cached;
  if (inFlight) return inFlight;
  inFlight = (async () => {
    const { data, error } = await supabase.functions.invoke("get-turnstile-sitekey");
    if (error || !data?.siteKey) {
      inFlight = null;
      return "";
    }
    cached = data.siteKey as string;
    inFlight = null;
    return cached;
  })();
  return inFlight;
};

export const useTurnstileSiteKey = () => {
  const [siteKey, setSiteKey] = useState<string>(cached ?? "");
  useEffect(() => {
    if (!cached) fetchSiteKey().then(setSiteKey);
  }, []);
  return siteKey;
};
